<template>
  <vx-card class="overflow-hidden" style="height:150px">
    <div slot="no-body">
      <vue-apex-charts :key="key"
                       height="180"
                       type="radialBar"
                       :options="extractedData.chartOptions"
                       :series="extractedData.series"></vue-apex-charts>
    </div>
  </vx-card>
</template>

<script>
export default {
  name: 'referrals-accepted-card',
  props: {
    data: Object,
    program: String,
    label: String,
    color: {
      type: String,
      default: 'primary'
    }
  },
  data () {
    return {
      extractedData: null,
      key: 0
    };
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler (value) {
        this.key++;
        const root = value.analysis.find(n => n.name === 'ROOT');
        const allTime = root.nested.find(n => n.name === 'ALL_TIME');
        const count = allTime.nested.find(n => n.name === 'ACTIVE').nested.find(n => n.name === 'COUNT');
        const countAccepted = allTime.nested.find(n => n.name === 'ACTIVE').nested.find(n => n.name === 'COUNT_ACCEPTED');
        const programs = allTime.nested.find(n => n.name === 'PROGRAMS');
        let acceptedPercentage = 0;
        let acceptedValue = 0;
        if (count.value) {
          if (!this.program) {
            acceptedPercentage = Math.round(100 * (countAccepted.value / count.value));
            acceptedValue = countAccepted.value;
          } else {
            const programBucket = programs.buckets.find(b => b.key === this.program);
            if (programBucket) {
              if (programBucket.nested.find(n => n.name === 'ACTIVE').nested.find(n => n.name === 'COUNT') && programBucket.nested.find(n => n.name === 'ACTIVE').nested.find(n => n.name === 'COUNT').value) {
                acceptedPercentage = Math.round(100 * (programBucket.nested.find(n => n.name === 'ACTIVE').nested.find(n => n.name === 'COUNT_ACCEPTED').value / programBucket.nested.find(n => n.name === 'ACTIVE').nested.find(n => n.name === 'COUNT').value));
                acceptedValue = programBucket.nested.find(n => n.name === 'ACTIVE').nested.find(n => n.name === 'COUNT_ACCEPTED').value;
              }
            }
          }
        }

        this.extractedData = {
          series: [acceptedPercentage],
          chartOptions: {
            chart: {
              type: 'radialBar'
            },
            colors: [this.color],
            plotOptions: {
              radialBar: {
                hollow: {
                  size: '70%'
                }
              }
            },
            labels: [`${acceptedValue} ${this.$t('reports.global.accepted')}`]
          }
        };
      }
    }
  }
};
</script>

<style scoped>

</style>
